module.exports = __webpack_public_path__ + "img/new-oil-card-icon.6456efa5.png";